import styled from "styled-components";

export const TableWrapper = styled.div`
    margin: 20px 0;
    border-radius: 20px;
`

export const Table = styled.table`
    text-align: center;
    max-width: 80%;
    border-collapse: collapse;
    margin: 0 auto;
    th {
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
        background: #212529;
        padding: 5px 10px;
    }

    td {
        font-size: 14px;
        padding: 5px 7px;

        textarea {
            width: 100%;
            height: 100%;
        }

        &:hover {
            background: #f2f2f2;
            font-weight: 600;
        }

        li {
            text-align: left;
            line-height: 25px;
        }
    }

    tr:nth-child(even) {
        background: #f2f2f2;
    }
`